const ffServerUrl = 'https://api.fuzzy-forms.cswlabs.cl';
const mapboxToken = 'pk.eyJ1Ijoic2ViYXBjYXJyb3phIiwiYSI6InBZSnJRY00ifQ.A1duNGXl-Z4Tt1vc_E0brA';
const baseMapUrl = `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/256/{z}/{x}/{y}?&access_token=${mapboxToken}`;

export { ffServerUrl, baseMapUrl };
